import { useMemo } from 'react';
import { useReportsDataContext } from 'pages/ReportsPage/ReportsPage.data.context';

export type LocationOption = {
  value: string;
  label: string;
  key: string;
};

interface FilterBarLocationData {
  locationOptions: LocationOption[];
  isLoading: boolean;
}

export const useFilterBarLocationData = (): FilterBarLocationData => {
  const { allCommunities = [], isLoadingCommunities = false } = useReportsDataContext();

  const locationOptions = useMemo(
    () =>
      allCommunities
        .map((community) => ({
          value: community.id,
          label: community.name ?? community.id,
          key: community.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [allCommunities],
  );

  return useMemo(
    () => ({ locationOptions, isLoading: isLoadingCommunities }),
    [locationOptions, isLoadingCommunities],
  );
};
